
export default {
  name: 'uk',
  el: {
    colorpicker: {
      confirm: 'Призначити',
      clear: 'Очистити',
    },
    datepicker: {
      now: 'Зараз',
      today: 'Сьогодні',
      cancel: 'Відміна',
      clear: 'Очистити',
      confirm: 'Гаразд',
      selectDate: 'Виберіть дату',
      selectTime: 'Виберіть час',
      startDate: 'Дата початку',
      endDate: 'Дата завершення',
      startTime: 'Час початку',
      endTime: 'Час завершення',
      prevYear: 'Попередній рік',
      nextYear: 'Наступний рік',
      prevMonth: 'Попередній місяць',
      nextMonth: 'Наступний місяць',
      year: '',
      month1: 'Січень',
      month2: 'Лютий',
      month3: 'Березень',
      month4: 'Квітень',
      month5: 'Травень',
      month6: 'Червень',
      month7: 'Липень',
      month8: 'Серпень',
      month9: 'Вересень',
      month10: 'Жовтень',
      month11: 'Листопад',
      month12: 'Грудень',
      week: 'тиждень',
      weeks: {
        sun: 'Нд',
        mon: 'Пн',
        tue: 'Вт',
        wed: 'Ср',
        thu: 'Чт',
        fri: 'Пт',
        sat: 'Сб',
      },
      months: {
        jan: 'Січ',
        feb: 'Лют',
        mar: 'Бер',
        apr: 'Квіт',
        may: 'Трав',
        jun: 'Черв',
        jul: 'Лип',
        aug: 'Серп',
        sep: 'Вер',
        oct: 'Жовт',
        nov: 'Лист',
        dec: 'Груд',
      },
    },
    select: {
      loading: 'Завантаження',
      noMatch: 'Немає відповідностей',
      noData: 'Немає даних',
      placeholder: 'Виберіть',
    },
    cascader: {
      noMatch: 'Немає відповідностей',
      loading: 'Завантаження',
      placeholder: 'Виберіть',
      noData: 'Немає даних',
    },
    pagination: {
      goto: 'Перейти',
      pagesize: 'на сторінку',
      total: 'Всього {total}',
      pageClassifier: '',
    },
    messagebox: {
      title: 'Повідомлення',
      confirm: 'Гаразд',
      cancel: 'Відміна',
      error: 'Неправильні дані',
    },
    upload: {
      deleteTip: 'Натисніть щоб видалити',
      delete: 'Видалити',
      preview: 'Переглянути',
      continue: 'Продовжити',
    },
    table: {
      emptyText: 'Немає даних',
      confirmFilter: 'Підтвердити',
      resetFilter: 'Скинути',
      clearFilter: 'Все',
      sumText: 'Сума',
    },
    tree: {
      emptyText: 'Немає даних',
    },
    transfer: {
      noMatch: 'Немає відповідностей',
      noData: 'Немає даних',
      titles: ['Список 1', 'Список 2'],
      filterPlaceholder: 'Введіть ключове слово',
      noCheckedFormat: '{total} елементів',
      hasCheckedFormat: '{checked}/{total} вибрано',
    },
    image: {
      error: 'ПОМИЛКА',
    },
    pageHeader: {
      title: 'Назад',
    },
    popconfirm: {
      confirmButtonText: 'Так',
      cancelButtonText: 'Ні',
    }
  },
}